import React from "react";
import { CircularProgress } from "@mui/material";
import { Modal } from "antd";
import CloseIcon from "@mui/icons-material/Close";

import styles from "../../../../../SwmsMasters/SwmsMastersStyle.module.css";

export default function EmergencyPlansToggleConfirmModal({ visible, targetEnabled, loading, onCancel, onConfirm, documentLabel = "Emergency Plans" }) {
  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={loading ? undefined : onCancel}
      maskClosable={!loading}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      destroyOnClose
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <div className="v2-modal-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className={styles.ModalHeading}>{targetEnabled ? `Enable ${documentLabel}?` : `Disable ${documentLabel}?`}</div>
              <hr className="v3-modal-hr" />
              <div>Are you sure you want to {targetEnabled ? "enable" : "disable"} {documentLabel} for this SWMS?</div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 pt-3 text-right">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "end", columnGap: "10px" }}>
                {loading ? <CircularProgress size={20} /> : null}
                <button type="button" className={styles.OutlinedButton} onClick={onCancel} disabled={loading}>Cancel</button>
                <button type="button" className={styles.PrimaryButton} onClick={onConfirm} disabled={loading}>Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
